import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';

const Spinner = (): JSX.Element => {
	const fontSize = 60;
	return (
		<LoadingOutlined style={{ fontSize, color: '#3091fd' }} />
	);
};

export default Spinner;
